import styled, { css } from 'styled-components';
export const Arrow = styled.span `
  position: absolute;
  width: 8px;
  height: 8px;
  z-index: -1;
  background: ${({ $type, theme }) => ($type === 'tooltip' ? theme.colors.black_1 : theme.colors.grey00_6)};
  transform: ${({ $styles }) => `${$styles.transform} rotate(45deg)`};
  top: ${({ $position }) => $position === 'bottom' && '-4px'};
  bottom: ${({ $position }) => $position === 'top' && '-4px'};
  ${({ $position }) => ($position === 'left' || $position === 'right') &&
    css `
      top: 0;
      left: ${$position === 'right' && '-4px'};
      right: ${$position === 'left' && '-4px'};
    `};
`;
export const Wrapper = styled.div `
  list-style: none;
  border-radius: ${({ theme }) => `${theme.borders.radiusMedium}px`};
  background: ${({ type, theme }) => (type === 'tooltip' ? theme.colors.black_1 : theme.colors.grey00_6)};
  color: ${({ type, theme }) => (type === 'tooltip' ? theme.colors.grey00_1 : theme.colors.black_1)};
  ${({ theme }) => theme.typography.textSmall};
  z-index: ${({ zIndex }) => zIndex || 1011};
  max-width: ${({ type }) => type !== 'popper' && '300px'};

  & a {
    color: ${({ theme }) => theme.colors.link100};

    &:hover {
      color: ${({ theme }) => theme.colors.link120_1};
      text-decoration: underline;
    }
  }
  ${({ type, theme }) => type === 'popper' &&
    css `
      ${theme.shadows.medium};
    `}
`;
export const Content = styled.div `
  ${({ autoSize }) => !autoSize &&
    css `
      max-height: 200px;
      box-sizing: border-box;
    `}
  padding: ${({ contentPadding }) => contentPadding && '8px 16px'};
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-line;
`;
export const Trigger = styled.div `
  display: inline-flex;
`;
